import { createFileRoute } from "@tanstack/react-router";

type GeneralSettingsSearch = { tab?: string | undefined };

export const Route = createFileRoute("/_app/general-settings/")({
  validateSearch: (search: Record<string, unknown>): GeneralSettingsSearch => ({
    tab: typeof search.tab === "string" ? search.tab : undefined,
  }),
});
